import axios from 'axios';
import setAuthHeader from './api/AuthHeader.js';
import { decode } from './helpers/decode_env.js';
// import LogoutModal from './modals/logoutModal.js';
// import ReactDOM from 'react-dom/client';

let showLogoutModalCallback = null;
export const setShowLogoutModalCallback = (callback) => {
  showLogoutModalCallback = callback;
};

// eslint-disable-next-line import/no-named-as-default-member
const axiosHandler = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL ? decode(process.env.REACT_APP_BASE_URL) : '',
  headers: {
    Accept: 'application/json',
  },
});

axiosHandler.interceptors.request.use(
  (config) => {
    // console.log('~~~~~~~~~~~~~~~~~~Making API reuest to: \n', config, '\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
    setAuthHeader()
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosHandler.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error) {
      if(error?.response?.status == 401) {
        if(showLogoutModalCallback){
          showLogoutModalCallback(true);
        }
      }
      if(error?.code == 'ERR_INVALID_URL'){
        // console.log('Invalid URL error:', error)
        return Promise.reject(new Error('API URL is incorrect or missing.'))
      }
      return Promise.reject(error);
    }
  }
);

export default axiosHandler;
